class ProductFinder extends HTMLElement {
  productTypeSelect: HTMLSelectElement | null = null;
  connectedCallback() {
    const cta = this.querySelector('button[data-role="product-finder-cta"]') as HTMLButtonElement | null;
    if (!cta) return;

    this.productTypeSelect = this.querySelector('select[name="product-type"]') as HTMLSelectElement | null;

    this.productTypeSelect?.addEventListener('change', () => {
      this.updateSelectedOption();
    });

    this.updateSelectedOption();

    cta.addEventListener('click', () => {
      const prefix = this.getAttribute('data-collections-url');
      const selected = this.querySelector(
        `[data-options="${this.productTypeSelect?.value}"] select`,
      ) as HTMLSelectElement | null;
      if (!prefix || !selected) return;

      const url = `${prefix}/${selected.value}`;
      window.location.assign(url);
    });
  }

  updateSelectedOption() {
    const options = this.querySelectorAll('.data-options');
    const selected = this.querySelector(`[data-options="${this.productTypeSelect?.value}"]`);
    options.forEach((el) => el.classList.add('hidden'));
    selected?.classList.remove('hidden');
  }
}

if (!customElements.get('product-finder')) {
  customElements.define('product-finder', ProductFinder);
}
